export const _getGeoLocation = () => {
  return fetch('https://get.geojs.io/v1/ip/geo.json')
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
};
